import { useState } from "react";
import "../../assets/Styles/PushNotification.css";
import { useFormik } from "formik";
import { useNavigate } from "react-router";
import { Snackbar } from "../../utils/snackbar";
import { SendMaintenanceInfo } from "../../services/Mainservice";

const MaintenanceInfo = () => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const navigate = useNavigate();

  const handleClose = (event, reason, setFunction) => {
    if (reason === "clickaway") return;
    setFunction(false);
  };

  const validate = (values) => {
    const errors = {};

    if (!values.title?.trim()) {
      errors.title = "Title is required";
    } else if (values.title.length > 50) {
      errors.title = "Title must be less than 50 characters";
    }

    if (!values.body?.trim()) {
      errors.body = "Message is required";
    } else if (values.body.length < 2) {
      errors.body = "Message must be at least 2 characters";
    } else if (values.body.length > 300) {
      errors.body = "Message must be less than 300 characters";
    }

    if (!values.windowStart) {
      errors.windowStart = "Maintenance time is required";
    }

    return errors;
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    const formattedDate = date
      .toLocaleDateString("en-CA", options)
      .replace(/\//g, "-");

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      const payload = {
        title: values.title.trim(),
        body: values.body.trim(),
        windowStart: formatDateTime(values.windowStart),
      };

      await SendMaintenanceInfo(payload);

      setSuccessMsg(
        "Maintenance information sent successfully"
      );
      setShowSuccess(true);

      formik.resetForm();
    } catch (error) {
      setErrorMsg(
        error.message || "Something went wrong"
      );
      setShowError(true);

      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      body: "",
      windowStart: "",
    },
    validate,
    onSubmit: handleSubmit,
  });

  return (
    <div className="container1">
      <h1 className="data_heading">
        Maintenance Information
      </h1>

      <form onSubmit={formik.handleSubmit}>
        {/* Title */}
        <div className="notification_input_div">
          <label
            htmlFor="title"
            className="Auth_label"
          >
            Title
          </label>

          <input
            type="text"
            id="title"
            name="title"
            className="notification_input"
            placeholder="Enter title..."
            value={formik.values.title}
            onChange={formik.handleChange}
          />

          {formik.errors.title && (
            <p className="invalid">
              {formik.errors.title}
            </p>
          )}
        </div>

        {/* Message */}
        <div className="notification_input_div">
          <label
            htmlFor="body"
            className="Auth_label"
          >
            Message
          </label>

          <textarea
            id="body"
            name="body"
            rows={4}
            className="notification_input"
            placeholder="Enter maintenance message..."
            value={formik.values.body}
            onChange={formik.handleChange}
          />

          {formik.errors.body && (
            <p className="invalid">
              {formik.errors.body}
            </p>
          )}
        </div>

        {/* Maintenance Window */}
        <div className="notification_input_div">
          <label
            htmlFor="windowStart"
            className="Auth_label"
          >
            Maintenance Start Time
          </label>

          <input
            type="datetime-local"
            id="windowStart"
            name="windowStart"
            className="notification_input"
            value={formik.values.windowStart}
            onChange={formik.handleChange}
          />

          {formik.errors.windowStart && (
            <p className="invalid">
              {formik.errors.windowStart}
            </p>
          )}
        </div>

        <button
          className="nf_button"
          type="submit"
          disabled={loading}
        >
          {loading
            ? "Sending..."
            : "Send Maintenance Info"}
        </button>
      </form>

      <Snackbar
        open={showSuccess}
        severity="success"
        onclose={() => setShowSuccess(false)}
        message={successMsg}
      />

      <Snackbar
        open={showError}
        severity="error"
        onclose={handleClose}
        message={errorMsg}
      />
    </div>
  );
};

export default MaintenanceInfo;